import { render } from "./SheetDescription.vue?vue&type=template&id=c2086a3a&ts=true"
import script from "./SheetDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetDescription.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2086a3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2086a3a', __exports__)) {
    api.reload('c2086a3a', __exports__)
  }
  
  module.hot.accept("./SheetDescription.vue?vue&type=template&id=c2086a3a&ts=true", () => {
    api.rerender('c2086a3a', render)
  })

}


export default __exports__